import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class MessageCypressAttribute extends CypressAttribute {
  static buttons = {
    SEND: 'MessageCypressAttribute:buttons:SEND',
    INLINE_SEND: 'MessageCypressAttribute:buttons:INLINE_SEND',
    COPY_TO_CLIPBOARD: 'MessageCypressAttribute:buttons:COPY_TO_CLIPBOARD',
    UNDO_DELETE: 'MessageCypressAttribute:buttons:UNDO_DELETE'
  };

  static views = {
    CHAT_MESSAGES_LIST: 'MessageCypressAttribute:views:CHAT_MESSAGES_LIST',
    MESSAGE_VIEW: 'MessageCypressAttribute:views:MESSAGE_VIEW',
    MESSAGE_CONTENT: 'MessageCypressAttribute:views:MESSAGE_CONTENT',
    MESSAGE_TIME: 'MessageCypressAttribute:views:MESSAGE_TIME'
  };
}
